import { CancelToken } from 'axios';

import { I_PayloadGetShows } from 'app/pages/Catalog/slice/types';
import { BaseXHR } from 'utils/axios';
import { addTicketType } from 'utils/helper';

export const getShowApi = (payload: I_PayloadGetShows) =>
  BaseXHR.$get('show/listing', payload);
export const getShowNewApi = (
  payload: I_PayloadGetShows,
  config?: { cancelToken: CancelToken },
) => BaseXHR.$get('b2b/v1/show/list-show', addTicketType(payload), config);
export const getCatalogApi = (id: any) =>
  BaseXHR.$get(`b2b/v1/catalog/listing?park=${id}`);
export const getCatalogListingApi = (payload?: any) =>
  BaseXHR.$get('b2b/v1/catalog/listing', payload);
export const getDetailShowApi = (payload: any) => {
  return BaseXHR.$get(
    `show/detail/${payload?.id}?channel=b2b&ticketType=${payload?.ticketType}`,
  );
};

export const getNewApi = (payload: any) =>
  BaseXHR.$get('news/listing', payload);
export const getPromotionParkApi = (payload: any) =>
  BaseXHR.$get(`promotions/ticket`, payload);
export const getPromotionApi = (payload: any) =>
  BaseXHR.$get('promotions/listing', payload);
export const getPriceCartApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/cart/get-price', addTicketType(data));
export const checkCartConfigApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/cart/check-config', data);
export const getPriceCartApiWithCancelRequest = (
  data: FormData,
  signal?: AbortSignal,
) => BaseXHR.$post('b2b/v1/cart/get-price', addTicketType(data), { signal });
export const getShowDetailApi = (data: any) =>
  BaseXHR.$get(
    `show/detail/${data?.id}?date=${data?.date}&channel=b2b&ticketType=${data?.ticketType}`,
  );
export const getRestaurantPerformanceListApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/show/performances-by-restaurant', data);
export const getUsedArea2 = (
  data: FormData,
  config?: { cancelToken: CancelToken },
) => BaseXHR.$post('b2b/v1/show/get-used-area2', addTicketType(data), config);
export const getTicketAddons = (payload: { showIds: number }) =>
  BaseXHR.$get('b2b/v1/show/addons', payload);
